module.exports = __webpack_public_path__ + "static/media/sidebar-14.1c366423.png";